import { useState, useEffect } from 'react'

export function useIsPhone() {
  const [isPhone, setIsPhone] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 1000)
    }

    // 监听窗口变化
    window.addEventListener('resize', handleResize)

    // 初始化触发一次（防止SSR或窗口未加载时）
    handleResize()

    // 清理事件
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isPhone
}
